import { Link } from 'react-router-dom';
import PublicNav from '../../../components/layout/PublicNav';

/**
 * About Component
 * 📋 Information about MnyMny application
 */
const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#6C5DD3] to-[#8247E5]">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white bg-opacity-95 backdrop-blur-sm rounded-3xl shadow-xl overflow-hidden">
          <div className="p-8 md:p-12">
            <PublicNav />

            <h1 className="text-3xl font-bold text-[#6C5DD3] mb-6">About MnyMny</h1>
            
            <div className="prose max-w-none">
              <p className="text-gray-700 text-lg mb-6">
                MnyMny is a comprehensive financial management platform designed for everyone who wants 
                to take control of their finances. Whether you're managing money solo or with a partner, 
                our AI-powered platform helps you track income sources, bank accounts, credit cards, loans, 
                budgeting, expenses, assets, and transactions—all in one place. With intelligent insights 
                powered by machine learning, we help you manage spending, build savings, pay off debts, 
                and plan for emergencies and retirement.
              </p>

              <h2 className="text-2xl font-semibold text-gray-800 mt-10 mb-4">Our Story</h2>
              <p className="text-gray-700 mb-4">
                MnyMny was born from the recognition that managing personal finances is complex, whether 
                you're doing it alone or with a partner. We saw that people needed a better way to see 
                their complete financial picture—income, accounts, budgets, expenses, and assets—in one 
                unified platform. We also recognized that everyone could benefit from intelligent guidance 
                to make better financial decisions.
              </p>
              <p className="text-gray-700 mb-4">
                We started as a simple income tracking tool and have evolved into a full-featured 
                financial management platform with robust budgeting, expense tracking, transaction 
                management, banking integration, and AI-powered insights. Our machine learning capabilities 
                help you understand your spending patterns, optimize your budget, pay off debt strategically, 
                and build wealth for your future.
              </p>
              <p className="text-gray-700 mb-4">
                While we're designed with individuals in mind, we also offer powerful partner features 
                for those who want to manage finances collaboratively. You can share accounts, budgets, 
                and financial goals with a partner while maintaining full control over your privacy settings.
              </p>

              <h2 className="text-2xl font-semibold text-gray-800 mt-10 mb-4">What Makes Us Different</h2>
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-5 rounded-xl">
                  <h3 className="text-xl font-medium text-[#6C5DD3] mb-2">AI-Powered Intelligence</h3>
                  <p className="text-gray-700">
                    Our machine learning engine analyzes your financial data to provide personalized 
                    recommendations for debt payoff, savings goals, budgeting, and retirement planning.
                  </p>
                </div>
                
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-5 rounded-xl">
                  <h3 className="text-xl font-medium text-[#6C5DD3] mb-2">Complete Financial Picture</h3>
                  <p className="text-gray-700">
                    Track everything in one place: income sources, bank accounts, credit cards, loans, 
                    budgets, expenses, assets, and transactions. No more switching between apps.
                  </p>
                </div>
                
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-5 rounded-xl">
                  <h3 className="text-xl font-medium text-[#6C5DD3] mb-2">Smart Categorization</h3>
                  <p className="text-gray-700">
                    Our AI-powered categorization system learns your spending patterns to automatically 
                    organize transactions and identify trends.
                  </p>
                </div>
                
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-5 rounded-xl">
                  <h3 className="text-xl font-medium text-[#6C5DD3] mb-2">Partner Features (Optional)</h3>
                  <p className="text-gray-700">
                    Designed for individuals first, with powerful optional partner features. Share accounts, 
                    budgets, and goals while maintaining full control over your privacy.
                  </p>
                </div>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-10 mb-4">Our Team</h2>
              <p className="text-gray-700 mb-4">
                We're a passionate team of financial experts, developers, and AI engineers committed to 
                making financial management accessible and intelligent for everyone. With backgrounds in 
                fintech, machine learning, personal finance, and user experience design, we bring a 
                unique perspective to solving the challenges of modern financial management.
              </p>

              <div className="flex justify-center mt-10">
                <Link 
                  to="/register" 
                  className="px-8 py-3 bg-gradient-to-r from-[#6C5DD3] to-[#8247E5] text-white font-medium rounded-xl hover:opacity-90 transition duration-200"
                >
                  Get Started for Free
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 